export default __webpack_public_path__ + "static/udemy-742f730d4ea919483c11357d0c22b44e.png";